export const environment = {
    production: false,
    devOrStaging: true,

    APIEndPoint: "https://dev.fieldjetx.com/fjxapi/api/",
    APIEndPointRefData: "https://dev.fieldjetx.com/fjxapi/api/",
    APIEndPointExternal: "https://dev.fieldjetx.com/fjxapi/api/external/",
    APIEndPoint_v2: "https://api-dev.fieldjetx.com/api/v1/",
    APICEndPoint: "https://dev.fieldjetx.com/FJXConnector/apic/",
    APIEndPointSignalR: "https://dev.fieldjetx.com/fjxapi/notify",
    AppUrlExpenseMaint: "https://expensemaintenance-dev.fieldjetx.com/",
    VersionRoute: "/version.txt",
    EnableVersionCheck: true,
    VersionCheckInterval: 60000, // 1 minute
    firebase: {

    },
    FieldInvoice: "https://www.fieldgetics.com/FieldJetXM/invoice.aspx?FieldInvoiceQueueId=",

    debug: true,
    log: {
        auth: false,
        store: false,
    },

    deployment: 'dev',
    appCode: 'FG2',

    releaseVersion: require('../../package.json').version,

    smartadmin: {
        api: null,
        db: 'smartadmin-angular'
    },
    useAuthMock: false,
    authConfig: {
        credentials: {
            clientId: "e28e432e-fd03-40bf-a7d8-7157178ec56f",
            tenantId: "522b35a5-68e2-4f5a-81dd-6ce68592d974"
        },
        configuration: {
            redirectUri: window.location.origin + "/auth/msal",
            postLogoutRedirectUri: window.location.origin + "/login"
        },
        resources: {
            apiScopes: ["api://5e763b8e-bd8a-44e0-a308-da2e335f7ff4/FJX_API_Dev"]
        },
        routes: [
            "" //we set an empty cause it joins with the baseApiUrl
        ]
    }
};
